
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import AudienceDetail from "./AudienceDetail";
import { useState } from "react";
import type { AudienceItem } from "./types";

interface DesktopAudienceViewProps {
  audiences: AudienceItem[];
  isVisible: boolean;
}

const DesktopAudienceView = ({ audiences, isVisible }: DesktopAudienceViewProps) => {
  const [activeTab, setActiveTab] = useState("aging-in-place");
  
  return (
    <div className={`transition-all duration-700 delay-200 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
      <Tabs defaultValue="aging-in-place" className="max-w-4xl mx-auto" onValueChange={setActiveTab}>
        <TabsList className="grid grid-cols-2 md:grid-cols-5 mb-8">
          {audiences.map((audience) => (
            <TabsTrigger 
              key={audience.id} 
              value={audience.id}
              className={`data-[state=active]:bg-abbella-aqua data-[state=active]:text-white px-3 py-2`}
            >
              {audience.title}
            </TabsTrigger>
          ))}
        </TabsList>
        
        {audiences.map((audience) => (
          <TabsContent 
            key={audience.id} 
            value={audience.id}
            className={`transition-all duration-500 ${activeTab === audience.id ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}
          >
            <AudienceDetail 
              title={audience.title}
              description={audience.description}
              image={audience.image}
              features={audience.features}
            />
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
};

export default DesktopAudienceView;
